import {
  FilterOperator,
  InvoiceStatus,
  SortDirection,
  type QueryParamsDto,
} from "@mimber/schema"
import type { ExportDuesInvoicesCsvFormData } from "./ExportDuesInvoicesCsvForm.schema"

export const DUES_INVOICE_STATUS_OPTIONS = Object.values(InvoiceStatus).map(
  (status) => ({
    label: status,
    value: status,
  })
)

export const DUES_INVOICE_SORT_FIELD_OPTIONS = [
  { label: "Invoice Number", value: "invoiceNumber" },
  { label: "Status", value: "status" },
  { label: "Issued Date", value: "issuedAt" },
  { label: "Due Date", value: "dueAt" },
  { label: "Total Amount", value: "totalAmount" },
] as const

export const DUES_INVOICE_SORT_DIRECTION_OPTIONS = [
  { label: "Ascending", value: SortDirection.ASC },
  { label: "Descending", value: SortDirection.DESC },
]

export const getExportDuesInvoicesCsvFormDefaults = (
  initialValues?: QueryParamsDto
): ExportDuesInvoicesCsvFormData => {
  const status = initialValues?.filters?.status?.[FilterOperator.EQUALS] as
    | InvoiceStatus
    | undefined
  const sortEntry = initialValues?.sort
    ? Object.entries(initialValues.sort)[0]
    : undefined

  return {
    search: initialValues?.search ?? "",
    status,
    sortField: sortEntry?.[0] as ExportDuesInvoicesCsvFormData["sortField"],
    sortDirection: sortEntry?.[1],
  }
}

export const buildDuesInvoicesExportQueryParams = (
  values: ExportDuesInvoicesCsvFormData
): QueryParamsDto | undefined => {
  const params: QueryParamsDto = {}

  if (values.search) {
    params.search = values.search
  }

  if (values.status) {
    params.filters = {
      status: {
        [FilterOperator.EQUALS]: values.status,
      },
    }
  }

  if (values.sortField && values.sortDirection) {
    params.sort = {
      [values.sortField]: values.sortDirection,
    }
  }

  return Object.keys(params).length > 0 ? params : undefined
}
